// Constants for DualRangeSliders
export const BEDS_MIN = 0;
export const BEDS_MAX = 5;
export const BEDS_STEP = 1;

export const BATHS_MIN = 0;
export const BATHS_MAX = 7;
export const BATHS_STEP = 1;

export const SQFT_MIN = 0;
export const SQFT_MAX = 7500;
export const SQFT_STEP = 250;

export const ACREAGE_MIN = 0;
export const ACREAGE_MAX = 10;
export const ACREAGE_STEP = 0.5;

export const YEAR_BUILT_MIN = 1800;
export const YEAR_BUILT_STEP = 1;

// Search limits
export const SEARCH_MAX_PROPERTIES = 600;
